var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Injectable, Inject } from '@angular/core';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';
import { DataSourceIdentifier } from '../data-source-identifier';
import { CONFIGURE_PROJECT_INFO } from '../../project/configure-project-info';
var RemoteDataSourceService = /** @class */ (function () {
    function RemoteDataSourceService(dataSourceService, projectInfo) {
        this.dataSourceService = dataSourceService;
        this.projectInfo = projectInfo;
    }
    RemoteDataSourceService.prototype.getDataSources = function () {
        return this.dataSourceService.getDataSourcesByConfigureId(this.projectInfo.id)
            .pipe(map(function (t) {
            return _.map(t, function (item) {
                return ({
                    id: new DataSourceIdentifier(item.code),
                    name: item.displayName
                });
            });
        }));
    };
    RemoteDataSourceService = __decorate([
        Injectable(),
        __param(1, Inject(CONFIGURE_PROJECT_INFO))
    ], RemoteDataSourceService);
    return RemoteDataSourceService;
}());
export { RemoteDataSourceService };
